export default "__VITE_ASSET__3d63ffe5__"